module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.0e704329.svg";